<template>
    <dl class="description-list-wrapper">
        <DescriptionItem :label="$t('조건명')">
            {{ detailData.name || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('조건 키')">
            {{ detailData.key || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('연산자')">
            {{ getOperatorName || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('값')">
            {{ valueText }}
        </DescriptionItem>
        <DescriptionItem :label="$t('설명')">
            {{ detailData.description || '-' }}
        </DescriptionItem>

        <div class="row-wrapper">
            <DescriptionItem :label="$t('등록일시')">
                {{ get_date(detailData.created_at) || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('수정일시')">
                {{ get_date(detailData.updated_at) || '-' }}
            </DescriptionItem>
        </div>
    </dl>
</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {operatorOptions} from '@shared/components/admin/pages/Management/CampaignConnectRule/Condition/data';
import {getDate} from '@shared/components/admin/pages/Management/common-data';

export default {
    name: 'ConditionDetail',
    components: {
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        }
    },
    computed: {
        // 0·false 도 값이다. 배열·객체는 JSON 으로 보여 준다
        valueText() {
            const {value} = this.detailData;
            if (value == null || value === '') return '-';
            return typeof value === 'object' ? JSON.stringify(value) : String(value);
        },
        getOperatorName() {
            return operatorOptions.find(option => {
                return option.value === this.detailData.operator;
            })?.text ?? null;
        },
        get_date() {
            return (date) => {
                return getDate(date);
            };
        }
    }
};
</script>
<style lang="scss" scoped>

</style>
